export default __webpack_public_path__ + "images/0xf26ff70573ddc8a90bd7865af8d7d70b8ff019bc.png";